import DocumentList from "./DocumentList";

export default function InvoiceList() {
  return <DocumentList variant="invoice" />;
}
